import { Resource } from '../i18n';

export const it: Resource = {
  misc: {
    storeName: 'Fable',
  },
  welcome: 'Benvenuto su store-fable!',
};
